type TFeatures = {
  denyUrls: string[]
  errorBlocklist: string[]
  ignoreErrors: string[]
}

const { REACT_APP_NODE_ENV } = process.env

let environment = REACT_APP_NODE_ENV

if (environment === 'pull_request' || environment === 'local') {
  environment = 'development'
}

const featureToggleSentryUrl = 'https://assets.cdn.plurall.net/ft/sentry'

const getSentryFeature = async (): Promise<TFeatures> => {
  try {
    const response = await fetch(
      `${featureToggleSentryUrl}/${environment}.json?v=${new Date().getTime()}`,
    )

    const features: TFeatures = await response.json()

    return features
  } catch {
    return {} as TFeatures
  }
}

export { getSentryFeature }
